import { hydraUiApi, useHydraUIAPIQuery } from '@/services/api';
import { useStore } from '@nanostores/react';
import { accountStore, userStore } from '@/services/auth/store';
import { hasDevHelperAccess } from './store';

export function useDevHelperAccess(): boolean {
  const user = useStore(userStore);
  const account = useStore(accountStore);
  return hasDevHelperAccess(account, user);
}

export function useDevHelperFeatureFlags(accountId: number | undefined, enabled = true) {
  return useHydraUIAPIQuery({
    queryKey: ['getFeatureFlags', accountId],
    queryFn: ({ signal }) =>
      hydraUiApi.accounts.getFeatureFlags({ params: { path: { account_id: String(accountId!) } }, signal }),
    queryConfig: {
      enabled: enabled && accountId != null,
      select: (data) => data.featureFlags ?? {},
    },
  });
}
